<template>
  <div class="card radius-10 ma-20">
    <div class="card-content pa-20">
      <figure class="image is-96x96 mx-auto">
        <img src="@/assets/images/icon_modal/icon_valid.png">
      </figure>
    </div>
    <div class="card-content pa-20 has-text-centered">
      <h4 class="has-text-weight-bold is-size-4">Proposition validée</h4>
      <p class="is-size-14px">Le commercial a été prévenu de votre validation et reviendra vers vous rapidement</p>
      <div class="mt-20">
        <b-button
          class="box-shadow-0 mr-10"
          type="is-primary"
          rounded
          @click="$emit('close')">
          Fermer
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { sendValidationEmail } from '@/services/mail/sendEmail';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  props: {
    valid: Boolean,
  },
  data: () => ({
    isNoReject: true,
  }),
  watch: {
    valid: {
      handler(val) {
        if (val) this.validMail();
      },
      immediate: true,
    },
  },
  computed: {
    ...Recommandation.mapGetters({
      getCommercial: 'commercial',
      getClient: 'pdv',
      getRecom: 'recom',
    }),
  },
  methods: {
    async validMail() {
      const commercial = this.getCommercial.prenom ? `${this.getCommercial.prenom},<br>` : '';
      const email = this.getCommercial.email ? this.getCommercial.email : '';
      await sendValidationEmail(this.$route.params.id, commercial, this.getClient.libelle, '', this.getRecom.themeCampagne, email);
    },
  },
};
</script>

<style>

</style>